import type { IAlertMessage } from './IAlertMessage';

export class FieldAlertMessage {
    alertMessage: IAlertMessage | null = null;
    field: string;
    translationKey?: string | null = null;

    constructor(field: string, message?: string, type?: 'success' | 'danger' | 'warning', translationKey?: string | null) {
        if (message && type) {
            this.alertMessage = { message, type };
        }

        this.field = field;
        this.translationKey = translationKey || field;
    }
}
